var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.a5d98786f47a3cf50e9c641d89ccb2bf.svg#r';
                    var viewUrl = 'sprites.a5d98786f47a3cf50e9c641d89ccb2bf.svg#view-r';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 104 36',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };